module.exports = __webpack_public_path__ + "static/media/hamburger.6958de6a.svg";